export const commonConstants = {

    MANIFEST_LIST_SUCCESS: 'GET_MANIFEST_LIST_SUCCESS',
    AIRLINES_CARRIERS_SUCCESS: 'GET_AIRLINES_CARRIERS_SUCCESS',
    AIRPORTS_SUCCESS: 'GET_AIRPORTS_SUCCESS'
};
